import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const portableTextBox = () =>
  css({
    fontFamily: theme.typography.fontFamily,
    fontSize: 16,
    lineHeight: 1.8,
    marginBottom: 32,
  });
